export default "__VITE_ASSET__CdOWaxz4__"